import { gql } from '@grandvisionhq/graphql';

var StoreOffersFragment = gql`
  fragment StoreOffers on Store {
    offers {
      title
      description
      url
      imageUrl
    }
  }
`;

export { StoreOffersFragment as default };
//# sourceMappingURL=store-offers.js.map
